export default "/images/fb58e864df075bf5de02ced604ce2fa9.avif";